module.exports = __webpack_public_path__ + "static/info-graphics-4334458bcfef0657b51821edf554a869.png";